const url = (inventoryId, itemId) => `/api/v1/inventory/${inventoryId}/inventory-items/${itemId}`;

export default url;
